import WeatherApp from "./components/weatherApp";

function App() {
  return <WeatherApp/> 
}

export default App;
